/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import { useExportProviderAlertReportListMutation } from "../../../../../slices/alertSlice"
import Debounce from "../../../../../CommonMethods/Debounce"
import Pagination from "../../../../../components/Pagination"
import Limit from "../../../../../components/Limit"
import GlobalContext from "../../../../../components/Context/GloablContext"
import CustomOverLay from "../../../../../components/CustomOverLay"
import SearchEmptyScreen from "../../../../../components/SearchEmptyScreen"
import ConfirmationPrompt from "../../../../../components/ConfirmationPrompt"
import AnimatedModel from "../../../../../components/Animation/AnimatedModel"
import moment from "moment"
import { convertDatesToEpochUTC } from "../../../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import TopBarDeviceAlert from "./Component/Topbar"
import Table from "./Component/Table"
import { limitReducer } from "../../../../../redux/MultiselectRows"
import { useGetProviderReportListQuery } from "../../../../../slices/reportSlice"
import { handleTotalUsers as handleTotalPatients, resetOrgList as resetPatientList } from "../../../../../redux/wellnessFilterSlice"
import { handleTotalUsers, resetOrgList as resetOrgUserList } from "../../../../../redux/wellnessFilterUserSlice"
import { handleTotalUsers as handleTotalOrgUser, resetOrgList } from "../../../../../redux/wellnessFilterOrganizationSlice"
import { handleTotalUsers as handleTotalProvider , resetOrgList as resetProviderList } from "../../../../../redux/wellnessFilterProviderSlice"
import { dataService } from "../../../../../services/data.services" 
import DeviceAlertReportsSearch from "./Component/AdvancedSearch"
import { resetDeviceAlertSearch, setDeviceAlertSearch, setDeviceAlertSearchApplied } from '../../../../../redux/deviceAlertReportSearchSlice';


export default function ProvidersAlerts({tab,setLoadingState}){
    const {setIsSearchOpen, isSearchOpen, setIsSideBar,isSideBar} = useContext(GlobalContext);
    const [exportProviderAlertList]=useExportProviderAlertReportListMutation()
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading,setLoading]=useState(false)
    const [isSortselected,setisSortSelected]=useState(false)
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [emptyField,setEmptyField]=useState(false);
    const [datePartialFilled,setDatePartialFilled]=useState(false)
    const deviceAlertSearch = useSelector(state => state.deviceAlertSearchData);

    
    const auth=useSelector(state=>state?.auth)

    const [selectedOrganizationName, setSelectedOrganizationName] = useState([{
        organization_name: '',
        organization_id: '',
    }]);
    const [subDivisionDataLoading,setSubDivisionDataLoading]= useState(false)
    const userArr=useSelector(state=>state?.subdivSelect?.subdivData?.checkedArr)
    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });
    const initialState={
        "start_date":searchParams?.get('start_date')?`${new Date(parseInt(searchParams?.get('start_date'))*1000).getFullYear()}-${String(new Date(parseInt(searchParams?.get('start_date'))*1000).getMonth() + 1).padStart(2, '0')}-${String(new Date(parseInt(searchParams?.get('start_date'))*1000).getDate()).padStart(2, '0')}`:new Date(),
        "end_date":searchParams?.get('end_date')?`${new Date(parseInt(searchParams?.get('end_date'))*1000).getFullYear()}-${String(new Date(parseInt(searchParams?.get('end_date'))*1000).getMonth() + 1).padStart(2, '0')}-${String(new Date(parseInt(searchParams?.get('end_date'))*1000).getDate()).padStart(2, '0')}`:new Date(),
    }
    const [filterValues,setFilterValues]=useState(initialState)

    // Before calling the API, ensure `tab` is removed from search params
    const getFilteredSearchParams = () => {
        const params = Object.fromEntries(searchParams);
        const { tab, ...filteredParams } = params; // Destructure to remove 'tab'
        return new URLSearchParams(filteredParams).toString();
    };
    const {data,isFetching,isLoading,status}=useGetProviderReportListQuery(getFilteredSearchParams(),
        {skip: skip||location.search===''}
    )
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.last_page = null
        params.last_id = null
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const handleDispatch = useCallback(()=>{
        if(location.search===''){
            setSkip(true)
        }
        if(location.state!==null&&location.state!==''&& !Array.isArray(location.state)){
            let params={};
            if(location?.state?.search!==''){
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'search':decodeURIComponent(location.state.search)
                }
            }else{
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                }
            }
            setSearchParams({...params})
        }
        else{
            if(!searchParams.get('page_number')) { 
                handleSearchParams('page_number', '1')
            }
            if(!searchParams.get('limit')){
                handleSearchParams('limit','15')
           
            }
            if(!searchParams.get('start_date')) { 
                handleSearchParams('start_date', convertDatesToEpochUTC(moment(filterValues?.start_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true))
            }
            if(!searchParams.get('end_date')) { 
                handleSearchParams('end_date', convertDatesToEpochUTC(moment(filterValues?.end_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false))
            }
            if(!searchParams.get('filter')) {
                handleSearchParams('filter', `true`)
            }
            if (!searchParams.get('last_id')) {
                data===undefined?handleSearchParams('last_id', null):handleSearchParams('last_id', data?.data?.[data?.data?.length-1]?._id);
            }
            if (!searchParams.get('last_page')) {
                handleSearchParams('last_page', null)
            }
            if (!searchParams.get('tab')) {
                handleSearchParams('tab', tab)
            }
        }
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
    },[location])

    useEffect(() => {
        handleDispatch()
        
    }, [handleDispatch]);

    useEffect(()=>{
        if(searchParams.size>=8){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        params['last_id']=null
        params['last_page'] =null
        setSearchParams({ ...params });
    }

    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum,last_id:(pageNum===1?null:searchParams?.get('page_number')>pageNum?(data?.data?.[0]?._id!==undefined?data?.data[0]?._id:null):(data?.data?.[data?.data?.length-1]?._id!==undefined?data?.data[data?.data?.length-1]?._id:null)),last_page:(pageNum===1?null:searchParams?.get('page_number')>pageNum?searchParams?.get('page_number'):searchParams?.get('page_number'))  }) 
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    if(isLoading){
        setLoadingState(true)
    }else{
        setLoadingState(false)
    }

    useEffect(()=>{
        fetchData()
    },[filterValues?.start_date,filterValues?.end_date])
    // https://apis-dev.accessibleremotecaremanagement.net/v1/patients/list-providers-alerts-report?page_number=1&last_page=null&last_id=null&filter=true&end_date=1737570599&start_date=1729967400&limit=15&search=patient_id%3DPAT%3Bage%3D2%3Balert_title%3Dne%3A0011%3Balert_message%3Dtest%3Bsender_user_id%3DMON%3Borganization_id%3DORG%3Backnowledged_by%3DPRO%3Balert_priority%3DHigh%3Backnowledged_at%3D1668105000&search_mode=or
    
    const fetchData = async() => {
        try{
            let res
            res = await dataService.GetAPI(`patients/alerts-dropdown?filter_type=patient&start_date=${convertDatesToEpochUTC(moment(filterValues?.start_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true)}&end_date=${convertDatesToEpochUTC(moment(filterValues?.end_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false)}&dropdown_type=provider-alerts&page_number=${1}&limit=20`)
            if(res.data.status===200){
                dispatch(handleTotalPatients([res?.data?.data?.total_count]))
            }
            res = await dataService.GetAPI(`patients/alerts-dropdown?filter_type=user&start_date=${convertDatesToEpochUTC(moment(filterValues?.start_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true)}&end_date=${convertDatesToEpochUTC(moment(filterValues?.end_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false)}&dropdown_type=provider-alerts&page_number=${1}&limit=20`)
            if(res.data.status===200){
                dispatch(handleTotalUsers([res?.data?.data?.total_count])) 
            }
            res = await dataService.GetAPI(`patients/alerts-dropdown?filter_type=organization&start_date=${convertDatesToEpochUTC(moment(filterValues?.start_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true)}&end_date=${convertDatesToEpochUTC(moment(filterValues?.end_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false)}&dropdown_type=provider-alerts&page_number=${1}&limit=20`)
            if(res.data.status===200){
                dispatch(handleTotalOrgUser([res?.data?.data?.total_count])) 
            }
            res = await dataService.GetAPI(`patients/alerts-dropdown?filter_type=provider&start_date=${convertDatesToEpochUTC(moment(filterValues?.start_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true)}&end_date=${convertDatesToEpochUTC(moment(filterValues?.end_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false)}&dropdown_type=provider-alerts&page_number=${1}&limit=20`)
            if(res.data.status===200){
                dispatch(handleTotalProvider([res?.data?.data?.total_count])) 
            }
        }catch(error){  
        }
    };

    useEffect(()=>{
        return(()=>{
            dispatch(resetPatientList())
            dispatch(resetOrgUserList())
            dispatch(resetOrgList())
            dispatch(resetProviderList())
        })
    },[])

    // apply search function (I need this code for final confrimation)
    const handleOnSubmit = (e) => {
        e.preventDefault();
    
        let searchString = '';
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `patient_id` and `patient_id_inverse` conditions
        if (deviceAlertSearch?.patient_id && deviceAlertSearch.patient_id.trim() !== '') {
            const patientIdPrefix = deviceAlertSearch.patient_id_inverse ? 'ne:' : '';
            const formattedPatientId = formatSearchValue(deviceAlertSearch.patient_id);
            searchString += `patient_id=${patientIdPrefix}${encodeURIComponent(formattedPatientId)};`;
        }

        // Check for `age` and `age_inverse` conditions
        if (deviceAlertSearch?.age && deviceAlertSearch.age.trim() !== '') {
            const agePrefix = deviceAlertSearch.age_inverse ? 'ne:' : '';
            const formattedAge = formatSearchValue(deviceAlertSearch.age);
            searchString += `age=${agePrefix}${encodeURIComponent(formattedAge)};`;
        }

        // Check for `alert_title` and `alert_title_inverse` conditions
        if (deviceAlertSearch?.alert_title && deviceAlertSearch.alert_title.trim() !== '') {
            const alertTitlePrefix = deviceAlertSearch.alert_title_inverse ? 'ne:' : '';
            const formattedAlertTitle = formatSearchValue(deviceAlertSearch.alert_title);
            searchString += `alert_title=${alertTitlePrefix}${encodeURIComponent(formattedAlertTitle)};`;
        }

        // Check for `alert_title` and `alert_title_inverse` conditions
        if (deviceAlertSearch?.alert_description && deviceAlertSearch.alert_description.trim() !== '') {
            const alertDescriptionPrefix = deviceAlertSearch.alert_description_inverse ? 'ne:' : '';
            const formattedAlertDescription = formatSearchValue(deviceAlertSearch.alert_description);
            searchString += `alert_message=${alertDescriptionPrefix}${encodeURIComponent(formattedAlertDescription)};`;
        }

        // check for acknowledge user id field 
        if (deviceAlertSearch?.user_id && deviceAlertSearch.user_id.trim() !== '') {
            const userIDPrefix = deviceAlertSearch.user_id_inverse ? 'ne:' : '';
            const formattedUserID = formatSearchValue(deviceAlertSearch.user_id);
            searchString += `sender_user_id=${userIDPrefix}${encodeURIComponent(formattedUserID)};`;
        }

        // check for organization id field
        if (deviceAlertSearch?.organization_id && deviceAlertSearch.organization_id.trim() !== '') {
            const orgIDPrefix = deviceAlertSearch.organization_id_inverse ? 'ne:' : '';
            const formattedOrgId = formatSearchValue(deviceAlertSearch.organization_id);
            searchString += `organization_id=${orgIDPrefix}${encodeURIComponent(formattedOrgId)};`;
        }

        // check for organization id field
        if (deviceAlertSearch?.provider_id && deviceAlertSearch.provider_id.trim() !== '') {
            const proIDPrefix = deviceAlertSearch.provider_id_inverse ? 'ne:' : '';
            const formattedProId = formatSearchValue(deviceAlertSearch.provider_id);
            searchString += `acknowledged_by=${proIDPrefix}${encodeURIComponent(formattedProId)};`;
        }

        // Handle `alert_priority` with optional inverse condition
        if (Array.isArray(deviceAlertSearch.alert_severity)) {
            const userStsPrefix = deviceAlertSearch.alert_severity_inverse ? 'ne:' : ''; 
            deviceAlertSearch.alert_severity.forEach(type => {
                searchString += `alert_priority=${userStsPrefix}${encodeURIComponent(type)};`;
            });
        }

        const { acknowledge_day, acknowledge_month, acknowledge_year } = deviceAlertSearch || {};

        // Check if only some of the fields are filled
        const isPartialDateFilled =
        (acknowledge_day && (!acknowledge_month || !acknowledge_year)) ||
        (acknowledge_month && (!acknowledge_day || !acknowledge_year)) ||
        (acknowledge_year && (!acknowledge_day || !acknowledge_month));

        if (isPartialDateFilled) {
            setDatePartialFilled(true);
            return;
        } else if (
            acknowledge_day === '--' &&
            acknowledge_month === '--' &&
            acknowledge_year === '----'
        ) {
            // All fields contain dashes, send __NULL__
            const acknowledgeDatePrefix = deviceAlertSearch.acknowledge_date_inverse ? 'ne:' : '';
            searchString += `acknowledged_at=${acknowledgeDatePrefix}__NULL__;`;
        } else if (acknowledge_day && acknowledge_month && acknowledge_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${acknowledge_year}-${String(acknowledge_month).padStart(2, '0')}-${String(acknowledge_day).padStart(2, '0')}`;

            // Create a Date object at midnight (00:00:00)
            const date = new Date(`${dateStr}T00:00:00`);

            // Convert to epoch time in seconds
            const epochDate = Math.floor(date.getTime() / 1000);
            const acknowledgeDatePrefix = deviceAlertSearch.acknowledge_date_inverse ? 'ne:' : ''; 

            // Add epoch to search string
            searchString += `acknowledged_at=${acknowledgeDatePrefix}${epochDate};`;
        }     

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
        
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: deviceAlertSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            last_id: null, // Reset last_id on new search
            last_page: null, // Reset last_page on new null
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setDeviceAlertSearchApplied());
    };
    
    return(
        <>
            <div className='bg-[#F9F3F5] pt-[14px] pl-[30px] h-full w-full overflow-x-hidden'>
                {/* <TopHeader title={"Alert Reports"}/> */}
                <div className='bg-white rounded-lg pt-6 h-[calc(100vh-184px)] relative'>
                    <div className="px-3.5">
                        <TopBarDeviceAlert 
                            title={'Provider Alerts'}
                            AddButton={true}
                            menuBar={(data!==undefined&&data?.data?.length>0&&selectedRows?.length>0) ? true : false}
                            ApplyFilter={((searchParams.get('unselected_patient_ids')===null)&&(searchParams.get('selected_patient_ids')===null)&&(searchParams.get('unselected_user_ids')===null)&&(searchParams.get('selected_user_ids')===null)&&(searchParams.get('selected_provider_ids')===null)&&(searchParams.get('unselected_provider_ids')===null)&&(searchParams.get('selected_organization_ids')===null)&&(searchParams.get('unselected_organization_ids')===null)&&data?.data?.length===0)||(data===undefined)?false:true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-observer/add-observer'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['Alert Timestamp', 'Patient ID', 'Patient Name', 'Age', 'Alert Title', 'Alert Severity', 'Alert Description','User ID', 'User Name', 'Provider Acknowledged Timestamp', 'Provider ID', 'Provider Name', 'Organization ID', 'Organization Name']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportProviderAlertList={exportProviderAlertList}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            userArr={userArr}
                            subDivisionDataLoading={subDivisionDataLoading}
                            TotalCount={parseInt(data?.total_count)}

                        />
                    </div>
                    <div className="relative mx-3.5">
                        {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Provider Alerts list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'w-full h-[calc(100vh-312px)]':'w-full h-[calc(100vh-312px)]'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                            <div>
                                <Table
                                    pageNumber={Number(searchParams.get('page_number')) || 1}
                                    List={data}
                                    handleSearchParams={handleSearchParams}
                                    sortValue={searchParams.get('sort') || ''}
                                    setisSortSelected={setisSortSelected}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                />
                            </div>
                            {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-[8px]">
                                <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                                <div className="flex items-center">
                                    <Limit
                                        limit={limit}
                                        setLimit={setLimit}
                                        handleNoOfRowsClick={handleNoOfRowsClick}
                                        isColumnSelect={isColumnSelect}
                                    />
                            
                                    <Pagination
                                        TotalCount={parseInt(data?.total_count)}
                                        totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                        handleOnClickPageNumber={handleOnClickPageNumber}
                                        // limit={Number(searchParams.get('limit'))}
                                        limit={parseInt(limit)}
                                    />
                                </div>
                            </div>}
                        </>:<>
                            {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false")||(searchParams.get('status')!==null||searchParams.get('start_date')!==null||searchParams.get('end_date')!==null||searchParams.get('organization_id')!==null||searchParams.get('subdivision_ids')!==null) ?
                                <SearchEmptyScreen monitorPatientList={true} text={"That filter combination has no result. Please try different criteria"} />
                                :
                                data?.total_count===0&&!searchParams.get("search")?
                                    <SearchEmptyScreen monitorPatientList={true} text={"That filter combination has no result. Please try different criteria"} />

                                    :((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                            }
                        </>}
                    </div>
                </div>
                {confirmationState.isOpen  && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                disabled={loading}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle= {confirmationState?.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==="active"?'Activate':'Deactivate'}
                                message = {confirmationState.rowData!==""?`Are you sure you want ${confirmationState?.rowData?.status==="inactive"? 'activate' : 'deactivate'} the observer?`:
                                    `Are you sure you want to ${confirmationState.multirow==='active'?'activate':'deactivate'} the following observers?`}
                                textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                                buttonName = {confirmationState.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==='active'?'Activate':'Deactivate'}
                                userList={confirmationState?.multirow===''?'':confirmationState?.multirow==="deactive"?(selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name):(selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name)}
                                loadingActivation={loading}
                            />
                        }
                    /> 
                }
                {isSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <DeviceAlertReportsSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                    providerAlertsSearch={true}
                />
                }
            </div>
        </>
   
    )
}


